module.exports = __webpack_public_path__ + "static/media/cinderblock.185e780a.png";